import { Box, Typography } from "@mui/material";
import React from "react";
import whattodo from "../../assets/images/What we do.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Orangelogo from "../../assets/images/Orangelogo.png";
import Knowmorebtn from "../../components/button/Knowmorebtn";

const OurExpertiseHeading = () => {
  return (
    <Box
      sx={{
        maxWidth: { xs: "100%", sm: "1440px" },
        margin: "0 auto",
        marginTop: { xs: "1rem", sm: "0", md: "2rem" },
        display: "flex",
        flexDirection: { xs: "column-reverse", sm: "row" },
        padding: { xs: "0rem 1.8rem", sm: "0rem 3rem" },
        backgroundColor: "#ecebeb",
      }}
    >
      <Box
        sx={{
          width: { xs: "100%", sm: "50%" },
        }}
      >
        <Box
          sx={{
            width: "4rem",
            marginTop: { xs: "1rem", sm: "2rem" },
          }}
        >
          <img src={Orangelogo} alt="" width="100%" />
        </Box>
        <Typography
          sx={{
            fontFamily: "Montserrat",
            fontSize: { xs: "0.8rem", sm: "1rem" },
            marginTop: "0.4rem",
            fontWeight: "400",
          }}
        >
          WHAT WE OFFER
        </Typography>
        <Typography
          variant="h4"
          sx={{
            fontFamily: "Montserrat",
            fontSize: { xs: "1.4rem", sm: "1.6rem" },
            fontWeight: "500",
            marginTop: "0.8rem",
          }}
        >
          Our <span style={{ color: "rgba(255, 102, 0, 1)" }}>Solutions</span>
        </Typography>
      </Box>
    </Box>
  );
};

export default OurExpertiseHeading;
